import axios from "axios";
import store from "@/store/index.js";
import { VueCookieNext } from "vue-cookie-next";
import { captureException } from "@sentry/vue";
import { t } from "ttag";
import "@/jsdoc/types/api";
import { getDeviceType } from "@/utils/device";

function showLoader() {
  store.dispatch("system/setLoaderStatus", true);
}

function hideLoader() {
  store.dispatch("system/setLoaderStatus", false);
}

function showAlertByStatus(response) {
  const alertContent = {
    title: t`Извините, произошла ошибка`,
    text: t`Попробуйте позже`,
  };

  if (response?.status >= 500 && response?.data?.error_title) {
    alertContent.title = t`${response.data.error_title}`;
    alertContent.text = t`${response.data.error_message}`;
  }

  store.dispatch("system/showAlert", alertContent);
}

function errorHandler(error) {
  if (error.response?.status === 401) {
    if (window.mobapp?.authorizeV2 && getDeviceType() === "ios") {
    if (window.mobapp?.authorizeV2) {
      window.mobapp.authorizeV2(
        JSON.stringify({
          successCallback: "window.successCallback",
          cancelCallback: "window.cancelCallback",
        })
      );
    }} else {
        window.location.href = `${process.env.VUE_APP_ENV_URL}/entrance`;
    }
    return Promise.reject(error);
  }

  if (error.config.showAlert) {
    showAlertByStatus(error.response);
  }

  captureException(error);
  hideLoader();
  return Promise.reject(error);
}

/**
 * @param {CustomMainApiInstance} api
 */
function initAuthCallbacks(api) {
  window.successCallback = (ticket) => {
    VueCookieNext.setCookie("ticket", ticket);
    api.defaults.headers.common.ticket = ticket;
  };

  window.cancelCallback = () => {
    window.location.href = "/entrance";
  };
}

function createMainApiInstance() {
  const REQUEST_TIMEOUT = 60; // seconds
  /**
   * @type {CustomMainApiInstance}
   */
  const api = axios.create({
    baseURL: window.mybank_settings.api.url,
    timeout: 1000 * REQUEST_TIMEOUT,
  });

  api.defaults.showLoader = true;
  api.defaults.showAlert = true;
  api.defaults.headers.common.ticket = VueCookieNext.getCookie("ticket");
  api.defaults.headers.common.locale = VueCookieNext.getCookie("locale");
  api.defaults.headers.common["Cache-Control"] = "no-cache";

  if (process.env.VUE_APP_MODE !== "production") {
    api.defaults.headers.common["test.user.group"] =
      VueCookieNext.getCookie("test.user.group");
  }

  initAuthCallbacks(api);

  api.interceptors.request.use(
    /**
     * @param {import("axios").AxiosRequestConfig & CustomRequestParams} config
     * @returns
     */
    (config) => {
      if (config.showLoader) {
        showLoader();
      }
      return config;
    },
    errorHandler
  );

  api.interceptors.response.use((response) => {
    hideLoader();
    return response.data;
  }, errorHandler);

  return api;
}

export default createMainApiInstance();
